import React from 'react'
import { ATLTextBody, TextAlignmentEnum } from '@appsimples/atlantica-react-native'
import { atlTheme } from '../atlTheme'
import { windowWidth } from '../constants/dimensions'
import styled from 'styled-components/native'
import { platformConfig } from '../constants/platform'

const MIN_WIDTH = 96
const MIN_HEIGHT = 96
const itemToWindowProportion = windowWidth <= 360 ? 2 : 3
const MenuItemWidth = windowWidth / itemToWindowProportion - 2 * atlTheme.SpacingBase
const MenuItemHeight = windowWidth <= 360 ? MIN_HEIGHT : MenuItemWidth

const TabItemContainer = styled.TouchableOpacity`
  width: ${MenuItemWidth}px;
  height: ${MenuItemHeight}px;
  min-width: ${MIN_WIDTH}px;
  min-height: ${MIN_HEIGHT}px;
  background: ${atlTheme.ColorSurface};
  border: 1px solid ${atlTheme.ColorLowContrast};
  border-radius: ${atlTheme.SpacingBase};
  padding: 10px;
  margin: ${atlTheme.SpacingAtomic}px;
`
const TabItemContainerWebApp = styled.TouchableOpacity`
  width: 16%;
  height: 250px;
  min-width: 165px;
  max-width: 265px;
  background: ${atlTheme.ColorSurface};
  border: 1px solid ${atlTheme.ColorLowContrast};
  border-radius: ${atlTheme.SpacingBase};
  display: flex;
  align-items: center !important;
  margin-bottom: ${atlTheme.SpacingMarginal};
`
const WrapperIcon = styled.View`
  justify-content: center;
  align-items: center;
  max-height: 85%;
`

const ImageIcon = styled.Image`
  width: 100%;
  height: 100%;
`

const ImageIconWebApp = styled.Image`
  width: 80%;
  height: 80%;
`

interface TabItemProps {
  onPress: () => void
  source: HTMLImageElement
  description: string
}

export const TabItem: React.FunctionComponent<TabItemProps> = ({ onPress, source, description }) => {
  return (
    <>
      {platformConfig.isWeb() ? (
        <TabItemContainerWebApp onPress={onPress}>
          <ImageIconWebApp source={source} />
          <ATLTextBody
            horizontalMargin={1}
            textAlignment={TextAlignmentEnum.center}
            labelBaseProps={{ multilineLimit: 2, fontSize: 22, lineHeight: 24, textColor: atlTheme.ColorBrand1Default }}
          >
            {description}
          </ATLTextBody>
        </TabItemContainerWebApp>
      ) : (
        <TabItemContainer onPress={onPress}>
          <WrapperIcon>
            <ImageIcon source={source} />
          </WrapperIcon>
          <ATLTextBody
            verticalMargin={1}
            horizontalMargin={1}
            textAlignment={TextAlignmentEnum.center}
            labelBaseProps={{ multilineLimit: 2, fontSize: 14, lineHeight: 24, textColor: atlTheme.ColorBrand1Default }}
          >
            {description}
          </ATLTextBody>
        </TabItemContainer>
      )}
    </>
  )
}
